import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
`;

export const HeaderRow = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const Title = styled.span`
  ${(props) => props.theme.fonts.variant.semiBold?.()};
  font-size: ${(props) => props.theme.fonts.size.b1 || '16px'};
  color: ${(props) => props.theme.colors.darkGray || '#2A2A2A'};
`;

export const ArrowWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease-in-out;
  transform: rotate(${(props) => (props.$isExpanded ? '0deg' : '90deg')});
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: hidden;
  transition: max-height 0.2s ease-in-out, opacity 0.2s ease-in-out;
  max-height: ${(props) => (props.$isExpanded ? '500px' : '0')};
  opacity: ${(props) => (props.$isExpanded ? 1 : 0)};
  pointer-events: ${(props) => (props.$isExpanded ? 'auto' : 'none')};
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.lighterGray} ${(props) =>
  props.theme.colors.highClearGray};

  /* WebKit (Chrome, Edge, Safari) */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.lighterGray};
    border-radius: 3px;
  }
`;

export const ListItem = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  padding: 8px;
  height: 36px;
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;

  ${(props) =>
      !props.$isSelected &&
      `
    &:hover {
      background-color: ${props.theme.colors.ghostWhite};
      border-radius: 8px;
    }
  `}

  ${(props) =>
    props.$isSelected &&
    `
    background-color: ${props.theme.colors.titanWhite};
    border-radius: 8px;
  `}
`;
